<template>
  <div>
    <transition name="fade">
      <div v-if="focusToOrder" class="sg-backdrop" @click="focusOrder(false)" />
    </transition>

    <!-- DEKSTOP -->

    <!-- banner -->
    <div class="d-none d-sm-block" style="position: absolute; left: 0;">
      <b-img
        :src="require('@/assets/img//fullwidth/bg-01.png')"
        fluid
      />
    </div>

    <b-container class="d-none d-sm-block" style="border-top: 0.1px solid white;">
      <b-row>
        <b-col>
          <CarouselBanner :contents="banner_contents" />
        </b-col>
      </b-row>

      <b-row class="justify-content-center" style="margin-top: -10px;" id="sct1d">
        <b-col cols="8" class="form-column p-3" style="z-index: 120;" v-scroll-to="{ el: '#sct1d', offset: -250 }" @click="focusOrder(true)" @mouseover="focusOrder(true)" @mouseleave="focusOrder(false)">
          <FormOrder />
        </b-col>
      </b-row>
    </b-container>

    <!-- member benefit -->
    <b-container class="my-5 p-3 text-center d-none d-sm-block">
      <b-row>
        <b-col class="m-1">
          <h3>Member Benefit</h3>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-3">
        <b-col cols="2" class="mx-1" v-for="(content, index) in benefit_content" :key="index">
          <b-img
            fluid
            :src="require('@/assets/icon/value/' + content.img)"
            :alt="content.img"
            style="max-width: 30%;"
          />
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="2" class="mx-1" v-for="(content, index) in benefit_content" :key="index">
          <h5>{{ content.title }}</h5>
        </b-col>
      </b-row>
    </b-container>

    <!-- why -->
    <b-container class="my-5 p-3 text-center d-none d-sm-block">
      <div style="position: absolute; left: 0; width:100%;">
        <b-img
          :src="require('@/assets/img/fullwidth/bg-02.png')"
          fluid
          style="opacity: 0.3; width:100%;"
        />
      </div>

      <b-row>
        <b-col class="mt-3">
          <h1>Why StarGuides ?</h1>
        </b-col>
      </b-row>

      <b-row v-for="(reason, index) in why_content" :key="index">
        <b-col class="why-card">
          <!-- IF -->
          <b-card
            v-if="reason.img_right"
            img-right
            class="mt-3 mx-6 why-card-body border-solid"
            :img-src="require('@/assets/icon/reason/' + reason.img)"
            :img-alt="reason.img"
          >
            <b-card-text class="text-left">
              <span class="sg-sub-heading-text">
                {{ reason.title }}
              </span>
              <p style="font-size: 18px;">
                {{ reason.subtitle }}
              </p>
              <div class="sg-divider" style="width: 150px;">&nbsp;</div>
            </b-card-text>
          </b-card>

          <!-- ELSE -->
          <b-card
            v-else
            img-left
            class="mt-3 mx-6 why-card-body border-solid"
            :img-src="require('@/assets/icon/reason/' + reason.img)"
            :img-alt="reason.img"
          >
            <b-card-text class="text-left">
              <span class="sg-sub-heading-text">
                {{ reason.title }}
              </span>
              <p style="font-size: 18px;">
                {{ reason.subtitle }}
              </p>
              <div class="sg-divider" style="width: 150px;">&nbsp;</div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>

    </b-container>

    <!-- top destination -->
    <b-container class="my-5 p-5 text-center d-none d-sm-block">
      <b-row>
        <b-col class="m-1">
          <h1>Top Destination</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" class="my-3" v-for="(destination, index) in top_destinations" :key="index">
          <b-card
            :img-src="destination.img"
            :img-alt="destination.country"
            img-top
            tag="article"
            style="max-width: 20rem;"
          >
            <b-card-text>
              <h4>{{ destination.country }}</h4>
              <h4>{{ destination.price }}</h4>
            </b-card-text>

            <b-button size="sm" variant="outline-primary" @click="bookNow(destination.city)">Book Now</b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <i style="font-size: 18px;">
            * Price may change at any order.
          </i>
        </b-col>
      </b-row>
    </b-container>

    <!-- coverage area -->
    <b-container class="my-5 p-5 text-center d-none d-sm-block">
      <b-row>
        <b-col class="m-1">
          <h1>Coverage Area</h1>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/England.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">England</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/Germany.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">Germany</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/France.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">France</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/Netherland.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">Netherland</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/Italy.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">Italy</h4>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/Turkey.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">Turkey</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/Malaysia.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">Malaysia</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/China.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">China</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/Japan.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">Japan</h4>
        </b-col>
        <b-col>
          <b-img
            :src="require('@/assets/img/country-flag/South Korea.png')"
            fluid
          />
          <h4 style="margin-top: 0.5rem;">South Korea</h4>
        </b-col>
      </b-row>
    </b-container>

    <!-- how it works -->
    <b-container class="my-5 p-3 text-center d-none d-sm-block">
      <b-row>
        <b-col class="m-1">
          <router-link style="text-decoration: none; color: black;" :to="{ name: 'HowItWorks' }"><h1>How It Works ?</h1></router-link>
        </b-col>
      </b-row>

      <b-row class="mt-3 justify-content-center">
        <b-col cols="4" class="mt-3" v-for="(content, index) in how_it_works_content" :key="index">
          <b-row>
            <b-col>
              <b-img
                :src="require('@/assets/icon/how-it-works/' + content.img)"
                fluid
                style="max-width: 80%;"
              />
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <h4 style="font-weight: 600;">
                {{ content.title }}
              </h4>
              <h6 style="font-weight: 400;">
                {{ content.subtitle }}
              </h6>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!-- testimonial -->
    <b-container class="my-5 p-3 text-center d-none d-sm-block">
      <b-row class="justify-content-end sg-explore" :style="{'background-image': 'url(' + require('@/assets/img/fullwidth/event-explore.png') + ')'}">
        <b-col>
          <h1>Testimonial</h1>
        </b-col>
        <b-col cols="4">
          <CarouselTestimonial :contents="testimonial_content" slidesToShow="2" :vertical="true" />
        </b-col>
      </b-row>
    </b-container>

    <!-- article -->
    <b-container class="my-5 p-3 text-center d-none d-sm-block">
      <b-row>
        <b-col class="m-1">
          <h1>Articles</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <CarouselArticle :contents="articles" @passToParent="readMore" />
        </b-col>
      </b-row>
    </b-container>

    <!-- partners -->
    <b-container class="my-5 p-3 text-center d-none d-sm-block">
      <b-row>
        <b-col class="m-1">
          <h1>Our Partners</h1>
        </b-col>
      </b-row>

      <b-row class="my-3 justify-content-center">
        <b-col cols="2" class="partner-logo">
          <b-img
            :src="require('@/assets/icon/partners/ifi.png')"
            alt="IFI"
            fluid
          />
        </b-col>
        <b-col cols="2" class="partner-logo">
          <b-img
            :src="require('@/assets/icon/partners/bca.png')"
            alt="BCA"
            fluid
          />
        </b-col>
        <b-col cols="2" class="partner-logo">
          <b-img
            :src="require('@/assets/icon/partners/midtrans.png')"
            alt="MidTrans"
            fluid
          />
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-5 d-none d-sm-block" />

    <!-- MOBILE -->

    <!-- banner -->
    <b-container class="d-block d-sm-none">
      <b-row style="background-color: #233c7c;">
        <b-col>
          <CarouselBanner :contents="banner_contents" />
        </b-col>
      </b-row>

      <b-row style="margin-top: -2em" id="sct1m">
        <b-col class="form-column-mobile" style="z-index: 120;" @click="focusOrder(true)">
          <FormOrder :options_country_city="options_country_city" />
        </b-col>
      </b-row>
    </b-container>

    <!-- member benefit -->
    <b-container class="mt-5 p-3 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h4>Member Benefit</h4>
        </b-col>
      </b-row>

      <b-row class="d-none">
        <b-col>
          <carousel
            :perPage=2
            :paginationEnabled=true
            :autoplay=false
            :scrollPerPage=false
            :autoplayTimeout=6000
            :autoplayHoverPause=true
            :loop=true
            :centerMode=true
          >
            <slide v-for="(value, index) in benefit_content" :key="index">
              <b-row>
                <b-col>
                  <b-img
                    :src="require('@/assets/icon/value/' + value.img)"
                    :alt="value.title"
                    fluid
                    style="max-width: 25%;"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span class="sg-sub-heading-text">{{ value.title }}</span>
                </b-col>
              </b-row>
            </slide>
          </carousel>
        </b-col>
      </b-row>

      <b-row class="justify-content-center d-none">
        <b-col cols="6" v-for="(value, index) in benefit_content" :key="index">
          <b-row>
            <b-col>
              <b-img
                :src="require('@/assets/icon/value/' + value.img)"
                :alt="value.title"
                fluid
                style="max-width: 30%;"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              {{ value.title }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="5">
          <b-row>
            <b-col>
              <b-img
                :src="require('@/assets/icon/value/icon-01.png')"
                alt='Easy Reschedule'
                fluid
                style="max-width: 35%;"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Easy Reschedule
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-row>
            <b-col>
              <b-img
                :src="require('@/assets/icon/value/icon-02.png')"
                alt='Consultation'
                fluid
                style="max-width: 35%;"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Consultation
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-3">
        <b-col cols="5">
          <b-row>
            <b-col>
              <b-img
                :src="require('@/assets/icon/value/icon-03.png')"
                alt='Event Alert'
                fluid
                style="max-width: 35%;"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Event Alert
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-row>
            <b-col>
              <b-img
                :src="require('@/assets/icon/value/icon-04.png')"
                alt='Guarantee'
                fluid
                style="max-width: 35%;"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Guarantee
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!-- why -->
    <b-container class="mt-3 p-3 text-center d-block d-sm-none">
      <div style="position: absolute; left: 0; width:100%;">
        <b-img
          :src="require('@/assets/img/fullwidth/bg-02.png')"
          fluid
          style="width:100%;"
        />
      </div>

      <b-row>
        <b-col class="m-1">
          <h3>Why StarGuides ?</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <CarouselReason :contents="why_content" />
        </b-col>
      </b-row>
    </b-container>

    <!-- top destination -->
    <b-container class="my-5 p-3 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h3>Top Destination</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <CarouselTopDestination :contents="top_destinations" @passToParent="bookNow" />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <i style="font-size: 18px;">
            * Price may change at any order.
          </i>
        </b-col>
      </b-row>
    </b-container>

    <!-- Coverage Area -->
    <b-container class="my-5 p-5 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h3>Coverage Area</h3>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/England.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">England</span>
        </b-col>
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/Germany.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">Germany</span>
        </b-col>
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/France.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">France</span>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/Netherland.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">Netherland</span>
        </b-col>
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/Italy.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">Italy</span>
        </b-col>
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/Turkey.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">Turkey</span>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/Malaysia.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">Malaysia</span>
        </b-col>
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/China.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">China</span>
        </b-col>
        <b-col cols="4">
          <b-img
            :src="require('@/assets/img/country-flag/Japan.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">Japan</span>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4" offset="4">
          <b-img
            :src="require('@/assets/img/country-flag/South Korea.png')"
            fluid
          />
          <span style="font-size: 14px; margin-top: 0.5rem;">South Korea</span>
        </b-col>
      </b-row>
    </b-container>

    <!-- how it works -->
    <b-container class="p-3 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h3>How It Works ?</h3>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <CarouselHowItWorks :content="how_it_works_content" />
        </b-col>
      </b-row>
    </b-container>

    <!-- testimonial -->
    <b-container class="mt-3 p-0 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h3>Testimonial</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <CarouselTestimonial :contents="testimonial_content" slidesToShow="1" :vertical="false" />
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-1 p-0 text-center d-block d-sm-none">
      <b-row>
        <b-col>
          <b-img
            :src="require('@/assets/img/fullwidth/testimonial.png')"
            fluid
          />
        </b-col>
      </b-row>
    </b-container>

    <!-- articles -->
    <b-container class="mt-3 p-3 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h3 style="margin-bottom: 0px;">Articles</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <CarouselArticle :contents="articles" @passToParent="readMore" />
        </b-col>
      </b-row>
    </b-container>

    <!-- partners -->
    <b-container class="mt-1 p-3 text-center d-block d-sm-none">
      <b-row>
        <b-col class="m-1">
          <h3>Our Partners</h3>
        </b-col>
      </b-row>

      <b-row class="my-3 justify-content-center">
        <b-col cols="3" class="partner-logo">
          <b-img
            :src="require('@/assets/icon/partners/ifi.png')"
            alt="IFI"
            fluid
          />
        </b-col>
        <b-col cols="3" class="partner-logo">
          <b-img
            :src="require('@/assets/icon/partners/bca.png')"
            alt="BCA"
            fluid
          />
        </b-col>
        <b-col cols="3" class="partner-logo">
          <b-img
            :src="require('@/assets/icon/partners/midtrans.png')"
            alt="MidTrans"
            fluid
          />
        </b-col>
      </b-row>
    </b-container>

    <!-- UNINFLUENCED -->
    <!-- whatsapp -->
    <div class="whatsapp-logo">
      <b-img @click="openWhatsApp" :src="require('@/assets/icon/social-media/whatsapp.png')" fluid />
    </div>
    <!-- modal date -->
    <b-modal
      ref="date-modal"
      centered
      size="lg"
      hide-header
      hide-footer
    >
      <ModalDate
        :start_date="order_data.start_date"
        :end_date="order_data.end_date"
        @setDate="saveOrderData"
      />
    </b-modal>
  </div>
</template>

<script>
// external dependencies
import moment from 'moment'
import VueJwtDecode from 'vue-jwt-decode'

// custom component
import CarouselArticle from '@/components/Carousel/Article'
import CarouselBanner from '@/components/Carousel/Banner'
import CarouselHowItWorks from '@/components/Carousel/HowItWorks'
import CarouselReason from '@/components/Carousel/Reason'
import CarouselTestimonial from '@/components/Carousel/Testimonial'
import CarouselTopDestination from '@/components/Carousel/TopDestination'
import FormOrder from '@/templates/FormOrder'
import ModalDate from '@/components/Order/ModalDate'

// api call

export default {
  name: 'Home',
  components: {
    CarouselArticle,
    CarouselBanner,
    CarouselHowItWorks,
    CarouselReason,
    CarouselTestimonial,
    CarouselTopDestination,
    FormOrder,
    ModalDate
  },
  data () {
    return {
      slide: 0,
      sliding: null,
      focusToOrder: false,
      order_data: {},

      banner_contents: [
        { img: 'banner-1-01-01.png' }
      ],
      benefit_content: [
        {
          img: 'icon-01.png',
          title: 'Easy Reschedule'
        },
        {
          img: 'icon-02.png',
          title: 'Consultation'
        },
        {
          img: 'icon-03.png',
          title: 'Event Alert'
        },
        {
          img: 'icon-04.png',
          title: 'Guarantee'
        }
      ],
      why_content: [
        {
          title: 'Help The Traveler',
          subtitle: 'Kami membantu semua StarGuides member untuk memberikan informasi sehingga dapat menggunakan waktu yang sangat efisien.',
          img: 'icon-01.png',
          img_right: true
        },
        {
          title: 'Safety',
          subtitle: 'Anda tidak perlu khawatir untuk jalan-jalan keluar negeri! Orang Indonesia yang sudah lama tinggal dan mengerti keadaan sekitar akan membantu dan menjaga anda selama perjalanan.',
          img: 'icon-02.png',
          img_right: false
        },
        {
          title: 'Low Price',
          subtitle: 'Sudah bukan waktunya lagi untuk diatur kemana dan kapan anda pergi, anda berhak menentukan kemana dan kapan pun anda akan pergi dengan harga yang sangat terjangkau.',
          img: 'icon-03.png',
          img_right: true
        },
        {
          title: 'Education',
          subtitle: 'Jangan cuma foto-foto saja! Guiders kami akan memberikan seputar informasi mengenai tempat dan sejarah di kota yang anda kunjungi.',
          img: 'icon-04.png',
          img_right: false
        }
      ],
      top_destinations: [
        {
          country: 'France',
          city: 'Paris',
          img: require('@/assets/img/destination/Paris.jpg'),
          price: 'Rp. 2,240,771*'
        },
        {
          country: 'Netherland',
          city: 'Amsterdam',
          img: require('@/assets/img/destination/Amsterdam.jpg'),
          price: 'Rp. 2,240,771*'
        },
        {
          country: 'United Kindom',
          city: 'London',
          img: require('@/assets/img/destination/UK.jpg'),
          price: 'Rp. 2,240,771*'
        },
        {
          country: 'Germany',
          city: 'Berlin',
          img: require('@/assets/img/destination/Germany.jpg'),
          price: 'Rp. 2,240,771*'
        },
        {
          country: 'Italy',
          city: 'Millan',
          img: require('@/assets/img/destination/Italy.jpg'),
          price: 'Rp. 2,240,771*'
        },
        {
          country: 'Japan',
          city: 'Tokyo',
          img: require('@/assets/img/destination/Japan.png'),
          price: 'Rp. 2,240,771*'
        }
      ],
      how_it_works_content: [
        {
          img: 'icon-01.png',
          title: '1. Pemesanan & Rencana',
          subtitle: 'Setelah melakukan pemesanan, Konsultasikan lah rute perjalanan kamu di Forum Chat dengan Guiders yang terpilih.'
        },
        {
          img: 'icon-02.png',
          title: '2. Guiders Yang Terpilih',
          subtitle: 'Hore ! Kamu telah di jemput Guiders yang terpilih dan siap mengantar kamu pergi.'
        },
        {
          img: 'icon-03.png',
          title: '3. Abadikan Momen!',
          subtitle: 'Yeay! Abadikan momen istimewamu bersama orang tersayang di tempat yang anda kunjungi.'
        },
        {
          img: 'icon-04.png',
          title: '4. Waktunya Pulang',
          subtitle: 'Sampai di lain kesempatan & dan temukan guiders lain yang siap mengantar anda di perjalanan berikutnya.'
        },
        {
          img: 'icon-05.png',
          title: '5. Review Guider',
          subtitle: 'Berikan review guiders sesuai kepuasan kamu.'
        }
      ],
      testimonial_content: [
        {
          name: 'Ukie Jaya Mahendra',
          who: 'Executive Vice President PT. BNI Sekuritas',
          text: 'Semuanya aman terkendali, service dari Guidersnya sangat oke.',
          img: 'ukie.png'
        },
        {
          name: 'Nurhayati Manoarfa',
          who: 'DPR RI Komisi V 2014-2019',
          text: 'Bagus, ramah, helpful, tau tempat2 ok bs jadi teman ngobrol teman diskusi pilih tempat barang dan kegiatan.',
          img: 'nurhayati.jpg'
        },
        {
          name: 'Koentjoro',
          who: 'Direktur Utama PT HK Realtindo',
          text: 'Kami diantar dan dilayani oleh mas Rifki dan team nya yg sangat menguasai medan dan lingkungan negara eropa. Sangat menyenangkan dan merasa aman untuk berada di lingkungan eropa.',
          img: 'koentjoro.jpeg'
        },
        {
          name: 'I Gde Yadnya Kusuma',
          who: 'Retired of Bank Indonesia',
          text: 'Tasya penuh tanggung jawab dlm mengguide tamunya dan selalu berusaha membantu, keramahan dan kerajinan utk selalu ingin membantu tamunya agar tetap dijaga.',
          img: 'igede.jpeg'
        },
        {
          name: 'Nugraha N',
          who: 'Senior Manager Hukum PT Bukit Asam Tbk',
          text: 'Kami sangat puas dengan pelayanan StarGuides selama liburan di Eropa, sopir/guide ramah dan akomodatif.',
          img: 'nugraha.jpg'
        },
        {
          name: 'Rudy Siregar',
          who: 'Direktur PT. Sejati Interlog',
          text: 'Sangat bertanggung jawab dan mengantar kami ke daerah wisata di France dan anak2 saya sangat senang dengan perhatian Raden selama kami di sana, pengalaman yang sangat luar biasa dan segalanya menjadi mudah bersama Raden.',
          img: 'rudy.jpeg'
        },
        {
          name: 'Eunike',
          who: '',
          text: 'Saya pakai starguides sangat puas, senang dan pelayanannya sangat memuaskan dari Guidersnya.',
          img: 'eunike.jpeg'
        },
        {
          name: 'Chika',
          who: '',
          text: 'Service yang di berikan Guidersnya bagus. Orangnya baik dan ramah, semua sesuai itineraries dan tepat waktu.',
          img: 'chika.jpeg'
        },
        {
          name: 'Therezia',
          who: '',
          text: 'Kami semua sudah tiba dgn selamat. Terima kasih banyak atas bantuannya, Avira baik sekali & sabar temani kita selama 2 hari di Paris.',
          img: 'therezia.jpeg'
        },
        {
          name: 'Ekwan',
          who: 'Hutama Karya',
          text: 'Guidersnya bagus sangat kooperatif, waktu saya menjadi efektif selama di Swiss. Saya Senang sekali ada yang menemani kami dan rombongan.',
          img: 'ekwan.jpeg'
        }
      ],
      articles: [
        {
          img: require('@/assets/img/articles/200204/thumbnail.jpg'),
          title: 'Destinasi Keluarga Cemara',
          caption: 'Banyak yang memilih Jepang sebagai destinasi wisata pilihan. Tapi kalau...',
          whereTo: 'Content_Article200204-destinasi-wisata-keluarga-cemara'
        },
        {
          img: require('@/assets/img/articles/1911261/thumbnail.jpg'),
          title: '7 Keajaiban Dunia',
          caption: '7 keajaiban dunia  adalah simbol dari warisan dunia dan saksi tingginya...',
          whereTo: 'Content_Article191126-7-keajaiban-dunia'
        },
        {
          img: require('@/assets/img/articles/1911262/thumbnail.jpg'),
          title: 'Hotel Penjara Karosta',
          caption: 'Sebuah tempat menginap pada umumnya tentu menawarkan rasa nyaman...',
          whereTo: 'Content_Article191126-hotel-penjara-karosta'
        },
        {
          img: require('@/assets/img/articles/1911263/thumbnail.jpg'),
          title: 'The Changing of the Guard',
          caption: 'The traditional ceremony of the old guard changing with the new...',
          whereTo: 'Content_Article191126-the-changing-of-the-guard'
        },
        {
          img: require('@/assets/img/articles/191014/thumbnail.jpg'),
          title: 'Cara Menghemat Ketika Berlibur',
          caption: 'Liburan natal dan akhir tahun adalah momen yang sangat ditunggu-tunggu...',
          whereTo: 'Content_Article191014'
        },
        {
          img: require('@/assets/img/articles/191017/thumbnail.jpg'),
          title: 'Tempat Menyeramkan Di Eropa',
          caption: 'Jika kita berbicara tentang tempat seram, maka tidak akan pernah ada habisnya...',
          whereTo: 'Content_Article191017'
        },
        {
          img: require('@/assets/img/articles/191029/thumbnail.png'),
          title: 'Selamat Pagi Indonesia MetroTV',
          caption: 'Terbentuk sejak tahun 2017 dan secara resmi berbadan hukum pada tahun 2019...',
          whereTo: 'Content_Article191029'
        }
      ]
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode
    }
  },
  methods: {
    // PREREQUISITES
    // yang urusan DOM
    onSlideStart: function (slide) {
      this.sliding = true
    },
    onSlideEnd: function (slide) {
      this.sliding = false
    },
    focusOrder: function (follow) {
      if (follow) {
        this.focusToOrder = true
      } else {
        this.focusToOrder = false
      }
    },
    readMore: function (whereTo) {
      this.$router.push({ name: whereTo })
    },
    openWhatsApp: function () {
      window.open('https://wa.me/628111774779', '_blank')
    },

    bookNow: function (destination) {
      // set country, city & service
      if (destination === 'Paris') {
        this.order_data.country = '5ccd68bcba49fad2ae76ee2f' // Perancis
        this.order_data.city = '5d2db6275acd62de83e6efea' // Paris
        this.order_data.service = '5d394ef4840ec424295d459e' // StarX -> Perancis
      } else if (destination === 'Amsterdam') {
        this.order_data.country = '5d4d91e9bab1d9edcb9d7cff' // Belanda
        this.order_data.city = '5d4d91e9bab1d9edcb9d7d00' // Amsterdam
        this.order_data.service = '5d514b57ed72566dc66fb4ae' // StarX -> Belanda
      } else if (destination === 'London') {
        this.order_data.country = '5ccd68bcba49fad2ae76ee31' // Inggris
        this.order_data.city = '5d2db6275acd62de83e6eff3' // London
        this.order_data.service = '5d394ef4840ec424295d45a8' // StarX -> Inggirs
      } else if (destination === 'Berlin') {
        this.order_data.country = '5ccd68bcba49fad2ae76ee1d' // Jerman
        this.order_data.city = '5d2db6275acd62de83e6effe' // Berlin
        this.order_data.service = '5d394ef4840ec424295d45a3' // StarX -> Jerman
      } else if (destination === 'Millan') {
        this.order_data.country = '5ccd68bcba49fad2ae76ee52' // Itali
        this.order_data.city = '5d2db6275acd62de83e6f005' // Millan
        this.order_data.service = '5d394ef4840ec424295d45ac' // StarX -> Itali
      } else if (destination === 'Tokyo') {
        this.order_data.country = '5d8adff0343cb83569b448a6' // Jepang
        this.order_data.city = '5d9f115e92bef806dee543ee' // Tokyo
        this.order_data.service = '5d8ae570343cb83569b448ca' // StarX -> Jepang
      }

      this.$refs['date-modal'].show()
    },
    saveOrderData: function (newDate) {
      // save order data
      this.$cookies.set('order_data', {
        start_date: moment(newDate.start).format('DD/MM/YYYY'),
        end_date: moment(newDate.end).format('DD/MM/YYYY'),
        duration: moment(newDate.end).diff(moment(newDate.start), 'days') + 1,

        country: this.order_data.country,
        city: this.order_data.city,
        service: this.order_data.service,
        interest: [ '5d1ccc1dbffc0f0ae2d95055' ]
      })

      if (this.user) {
        this.$router.push({ name: 'Order' })
      } else {
        this.$router.push({
          name: 'Login',
          params: {
            whereTo: 'Order'
          }
        })
      }
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
/* custom margin */
.mx-6 {
  margin-left: 7rem !important;
  margin-right: 7rem !important;
}
/* END custom margin */

/* layering control for order form & banner */
.form-column {
  background-color: white;
  border-radius: 15px;

  min-height: 40px;

  /* x,y, blur, spread color */
  box-shadow: 0 20px 20px 10px rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.form-column-mobile {
  background-color: white;
  border-radius: 15px;

  /* margin: 10px 20px; */

  box-shadow: 0 20px 20px 10px rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
/* END layering control for order form & banner */

/* why background color */
.why-card .card-img-left {
  max-width: 150px;
  max-height: 150px;
}
.why-card-body {
  border: 0px;
  border-radius: 15px;
  background-color: white;
}
/* END why background color */

/* partner logo */
.partner-logo {
  margin: auto 0.25rem;
  padding: 0.5rem;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 15px;
  border: 1px solid #dddddd;
  background-color: #ffffff;
}
.whatsapp-logo {
  position: fixed;
  z-index: 1000;

  cursor: pointer;
}
@media screen and (max-width: 575px) {
  .whatsapp-logo {
    max-width: 15vw;
    right: 5vw;
    bottom: 3vh;
  }
}
@media screen and (min-width: 576px) {
  .whatsapp-logo {
    max-width: 4vw;
    right: 3vw;
    bottom: 5vh;
  }
}
/* END partner logo */

/* StarGuides Style Standart */
.sg-sub-heading-text {
  color: #233c7c;
  font-weight: 600;
}
@media screen and (max-width: 575px) {
  .sg-sub-heading-text {
    font-size: 15px;
  }
}
@media screen and (min-width: 576px) {
  .sg-sub-heading-text {
    font-size: 23px;
  }
}
.sg-counter-number {
  color: #728294;
  font-weight: 600;
}
@media screen and (max-width: 575px) {
  .sg-counter-number {
    font-size: 24px;
  }
}
@media screen and (min-width: 576px) {
  .sg-counter-number {
    font-size: 50px;
  }
}
.sg-explore {
  height: 750px;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
}
.sg-divider {
  background-color: #233c7c;
  border-radius: 10px;
  height: 10px;
}
/* END StarGuides Style Standart */

/* fade transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* END fade transition */

.card {
  border-radius: 15px;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
}
.card-img-top {
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}
.card-body {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue